"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withErrorBoundary = void 0;
const react_1 = require("react");
const error_boundary_1 = require("@kyruus/error-boundary");
const hooks_1 = require("../../lib/hooks");
const error_fallback_1 = __importDefault(require("./error-fallback"));
function withErrorBoundary(component, errorBoundaryProps) {
    const name = component.displayName || component.name || 'Unknown';
    const Wrapped = (0, react_1.forwardRef)((props, ref) => {
        const onError = (0, hooks_1.useTrackBoundaryError)(name);
        const newErrorBoundaryProps = Object.assign({ FallbackComponent: error_fallback_1.default, onError }, errorBoundaryProps);
        return (0, react_1.createElement)(error_boundary_1.ErrorBoundary, newErrorBoundaryProps, (0, react_1.createElement)(component, Object.assign(Object.assign({}, props), { ref })));
    });
    Wrapped.displayName = `withErrorBoundary(${name})`;
    return Wrapped;
}
exports.withErrorBoundary = withErrorBoundary;
//# sourceMappingURL=with-error-boundary.js.map